import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { Button, ButtonGroup, Image } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'

import HeroWithImage from 'components/HeroWithImage'
import data from './data'

const StyledButtonPrimary = styled(Button.Primary)`
  ${screenMin.m`
    max-width: 225px;
  `};
`

const StyledImage = styled(Image)`
  max-width: 425px;
`

const SliceHero = (): React.ReactElement => (
  <HeroWithImage
    title={data.title}
    subtitle={data.subtitle}
    additionalContent={
      <>
        <ButtonGroup align="left" horizontal leftToRight>
          {data.ctaLinks.map((ctaLink) => (
            <StyledButtonPrimary
              tag={Link}
              to={ctaLink.to}
              key={ctaLink.text}
              stretch
            >
              {ctaLink.text}
            </StyledButtonPrimary>
          ))}
        </ButtonGroup>
      </>
    }
    image={
      <StyledImage
        loading="eager"
        path={data.imagePath}
        width={300}
        widthFromM={600}
        stretch
      />
    }
  />
)

export default SliceHero
